import { z } from "zod";

/**
 * 统一错误结构。成功直接返回约定资源，错误通过 HTTP 状态与稳定 code 表达。
 * 页面按 code 判断，不匹配 message。
 */
export const apiErrorSchema = z.object({
  code: z.string().min(1),
  message: z.string(),
  requestId: z.string().min(1),
  details: z.record(z.string(), z.unknown()).optional(),
});

export type ApiError = z.infer<typeof apiErrorSchema>;

/** 设计保存冲突时返回 409，客户端保留本地草稿，允许另存或重新加载，不静默覆盖。 */
export const CONFLICT_STATUS = 409;
